import { Builder } from '@builder.io/react';
import React, { useEffect, useState } from "react";
import { BuilderComponent } from "@builder.io/react";
import { builderClient } from '@/utils/builder';
import { reportError } from '@/helpers/errorHelper';
import dynamic from 'next/dynamic';

const FinalSaleBanner = ({ builderTargetingData }) => {
  const [builderContentJson, setBuilderContentJson] = useState(null);

  useEffect(() => {
    try {
      builderClient
        .get("final-sale-pdp", {
          userAttributes: {
            ...builderTargetingData,
          }        })
        .promise()
        .then((res) => {
          if(res){
            setBuilderContentJson(res);
          }
        })
        .catch((err) => {
          setBuilderContentJson(null);
          reportError("Builder Final Sale Banner error:", err);
        });
    } catch (err) {
      reportError("Builder Final Sale Banner error:", err);
    }
  }, [builderTargetingData]);

  return (
    <div className={`final-sale-pdp`}>
      {builderContentJson &&
        <BuilderComponent model="final-sale-pdp" content={builderContentJson} />}
    </div>
  );
};

const FinalSalePDP = dynamic(async () => {
    return (await import("./FinalSalePDP")).default;
});

Builder.registerComponent(FinalSalePDP, {
  name: 'Final Sale Banner PDP',
  inputs: [
    {
      name:"gaTrackingName",
      type:"string",
      helperText:"Name for GA tracking",
    },
    {
      name: "backgroundColor",
      type: "string",
      helperText: "Background color of the Final Sale banner (Hex value eg.#d6c5b9)",
    },
    {
      name: "fontColor",
      type: "string",
      helperText: "Font color of the Final Sale banner (Hex value eg.#d6c5b9)",
    },
    {
      name: "desktopMessage",
      type: "object",
      helperText: "Message and url for desktop devices",
      subFields: [
      { 
        name: "bannerText", 
        type: "longText", 
        helperText: "Promo message for desktop" 
      },
      { 
        name: "url", 
        type: "url", 
        helperText: "URL the customer is redirected to when they click on the message on the website" 
      },
      ],
    },
    {
      name: "mobileMessage",
      type: "object",
      helperText: "Message and url for mobile devices",
      subFields: [
      { 
        name: "bannerText", 
        type: "longText", 
        helperText: "Promo message for mobile" 
      },
      { 
        name: "url", 
        type: "url", 
        helperText: "URL for mobile (optional)" 
      },
      ],
    },
    {
      name: "tabletMessage",
      type: "object",
      helperText: "Message and url for tablet devices",
      subFields: [
      { 
        name: "bannerText", 
        type: "longText", 
        helperText: "Promo message for tablet" 
      },
      { 
        name: "url", 
        type: "url", 
        helperText: "URL for tablet (optional)" 
      },
      ],
    },
  ],
});

export default FinalSaleBanner;